/* Optional, once-per-checkout priority-processing offer. No OCU dependency. */
(() => {
  const dialog = document.getElementById('mr-skip-dialog');
  if (!dialog || !dialog.showModal || window.MRSkipLine) return;
  window.MRSkipLine = true;
  const variant = Number(dialog.dataset.variant);
  const root = (dialog.dataset.root || '/').replace(/\/?$/, '/');
  const accept = dialog.querySelector('#mr-skip-accept');
  const decline = dialog.querySelector('#mr-skip-decline');
  const status = dialog.querySelector('#mr-skip-status');
  const acceptLabel = accept.textContent;
  let pending = false, busy = false, bypass = false, resume, previousFocus;
  const hasService = cart => cart.items.some(item => Number(item.variant_id || item.id) === variant && item.quantity > 0);
  async function cart() {
    const response = await fetch(root + 'cart.js', {cache:'no-store',credentials:'same-origin'});
    if (!response.ok) throw new Error('Could not check your cart.');
    return response.json();
  }
  function proceed() {
    dialog.close(); pending = false; bypass = true;
    const next = resume; resume = null;
    try { next?.(); } finally { setTimeout(() => { bypass = false; }, 1000); }
  }
  function fitNote() {
    const n = dialog.querySelector('.note');
    if (!dialog.open || !n.clientWidth) return;
    n.style.whiteSpace = 'nowrap';
    let low=1, high=12;
    for(let i=0;i<16;i++) { const mid=(low+high)/2; n.style.setProperty('font-size',mid+'px','important'); const r=document.createRange();r.selectNodeContents(n);if(r.getBoundingClientRect().width<=n.clientWidth-1)low=mid;else high=mid; }
    n.style.setProperty('font-size',low+'px','important');
  }
  async function offer(next) {
    if (pending) return;
    pending = true; resume = next; previousFocus = document.activeElement;
    try {
      const current = await cart();
      if (!current.items.length || hasService(current)) { proceed(); return; }
      busy = false; accept.disabled = false; decline.disabled = false; accept.textContent = acceptLabel;
      status.hidden = true; status.textContent = '';
      dialog.showModal(); fitNote(); document.fonts?.ready.then(fitNote);
    } catch (_) { proceed(); }
  }
  function checkoutLink(target) {
    if (!target.matches('a[href]')) return false;
    try { const u=new URL(target.href,location.href);return u.origin===location.origin && /\/checkout\/?$/.test(u.pathname); } catch (_) {return false;}
  }
  document.addEventListener('click', event => {
    if (bypass || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target=event.target.closest?.('button,input[type="submit"],a[href]');
    if (!target || target.disabled || target.closest('#mr-skip-dialog') || target.closest('.shopify-payment-button,.additional-checkout-buttons')) return;
    if (!(target.matches('[name="checkout"],.cart__checkout-button,#kaching-cart__checkout-button') || checkoutLink(target))) return;
    event.preventDefault(); event.stopImmediatePropagation();
    offer(() => { if(target.isConnected)target.click();else location.assign(root+'checkout'); });
  }, true);
  document.addEventListener('submit', event => {
    if(bypass) return;
    const form=event.target, button=event.submitter;
    if(!button?.matches('[name="checkout"],.cart__checkout-button,#kaching-cart__checkout-button')) return;
    event.preventDefault();event.stopImmediatePropagation();
    offer(() => { if(form.isConnected)form.requestSubmit(button);else location.assign(root+'checkout'); });
  },true);
  decline.addEventListener('click', () => { if(!busy)proceed(); });
  dialog.addEventListener('cancel', event => { event.preventDefault(); if(!busy)proceed(); });
  dialog.addEventListener('click', event => event.stopPropagation());
  accept.addEventListener('click',async () => {
    if(busy)return;busy=true;accept.disabled=true;decline.disabled=true;accept.textContent='Adding…';
    try {
      if(!hasService(await cart())) {
        const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant,quantity:1}]})});
        if(!response.ok)throw new Error('Could not add Skip the Line.');
      }
      proceed();
    } catch (_) {
      try { if(hasService(await cart())) { proceed(); return; } } catch (_) {}
      status.hidden=false;status.textContent='We couldn’t confirm the addition. You can continue to checkout and review your order.';
      accept.textContent=acceptLabel;accept.disabled=true;decline.disabled=false;
    } finally {busy=false;}
  });
  new ResizeObserver(fitNote).observe(dialog.querySelector('.copy'));
})();
